/* src/app/components/lead-details/participant-information/provider-classification/provider-classification.component.css */
.provider-classification {
  padding: 8px 0;
}
.classification-question {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 20px;
}
.classification-label {
  font-weight: 600;
}
.classification-answer {
  margin-top: 6px;
}
.required {
  color: red;
}
.classification-answer ::ng-deep .ant-radio-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  column-gap: 32px;
  row-gap: 8px;
}
.classification-fields {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-bottom: 20px;
}
.classification-field {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 260px;
}
.classification-field .classification-answer {
  width: 100%;
}
.derived-provider-type {
  border-top: 1px solid #e2f4f3;
  padding-top: 16px;
  margin-bottom: 8px;
}
.derived-note {
  font-size: 12px;
  margin: 6px 0 0 0;
}
/*# sourceMappingURL=provider-classification.component-UHKCT4LE.css.map */
